import axios from "axios";
import { API_URL } from "../constants";

export type ProjectDeskEmailThread = {
  id: string;
  number: number;
  title: string;
  emailSubject: string | null;
  status: string;
  preview: string | null;
  messageCount: number;
  lastMessageAt: number | null;
  lastReplyFrom: string | null;
  contact: { id: string; name: string | null } | null;
};

export type SendProjectDeskEmailParams = {
  to: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  text: string;
  html?: string;
  mailboxId?: string;
  cardNumber?: number;
  contactName?: string;
  files?: File[];
};

export async function fetchProjectDeskEmails(
  companyId: string,
  projectId: string
): Promise<{ threads: ProjectDeskEmailThread[] }> {
  const res = await axios.get(
    `${API_URL}/${companyId}/projects/${projectId}/desk-emails`
  );
  return res.data;
}

export async function sendProjectDeskEmail(
  companyId: string,
  projectId: string,
  body: SendProjectDeskEmailParams
) {
  const files = body.files || [];
  if (files.length) {
    const form = new FormData();
    form.append("to", body.to);
    if (body.cc) form.append("cc", body.cc);
    if (body.bcc) form.append("bcc", body.bcc);
    if (body.subject) form.append("subject", body.subject);
    form.append("text", body.text);
    if (body.html) form.append("html", body.html);
    if (body.mailboxId) form.append("mailboxId", body.mailboxId);
    if (body.cardNumber != null) {
      form.append("cardNumber", String(body.cardNumber));
    }
    if (body.contactName) form.append("contactName", body.contactName);
    files.forEach((file) => form.append("files", file, file.name));
    const res = await axios.post(
      `${API_URL}/${companyId}/projects/${projectId}/desk-emails/send`,
      form
    );
    return res.data;
  }

  const res = await axios.post(
    `${API_URL}/${companyId}/projects/${projectId}/desk-emails/send`,
    {
      to: body.to,
      cc: body.cc,
      bcc: body.bcc,
      subject: body.subject,
      text: body.text,
      html: body.html,
      mailboxId: body.mailboxId,
      cardNumber: body.cardNumber,
      contactName: body.contactName,
    }
  );
  return res.data;
}
